import { Box } from "@mui/material";
import { NoData } from "components/dataDisplay/NoData";
import type { FC, ReactNode } from "react";

export interface TextDisplayProps {
  value: string | undefined;
  fallback?: ReactNode;
}

export const TextDisplay: FC<TextDisplayProps> = ({ value, fallback }) => {
  return (
    <Box style={{ wordWrap: "break-word" }}>
      {value ?? fallback ?? <NoData />}
    </Box>
  );
};
